import { useMemo } from "react";
import "./TabelaReembolso.css";

export interface TituloItem {
  filial?: string;
  numeroTitulo?: string;
  numero?: string;
  titulo?: string;
  natureza?: string;
  emissao?: string | null;
  vencimento?: string | null;
  atrasoDias?: number;
  atraso?: number;
  valor?: number;
  historico?: string;
  status?: string;
}

const formatCurrency = (v: number | string | undefined) =>
  (Number(v) || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

const formatDateBR = (iso: string | undefined | null) => {
  if (!iso) return "-";

  const d = new Date(iso);

  if (Number.isNaN(d.getTime())) return "-";

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();

  return `${dd}/${mm}/${yyyy}`;
};

const StatusText = ({ value }: { value?: string }) => {
  const s = String(value || "")
    .trim()
    .toLowerCase();

  const isBaixado =
    s === "baixado" || s === "pago" || s === "finalizado";

  return (
    <span className={`status-titulo ${isBaixado ? "ok" : "warn"}`}>
      {(value || "-").toUpperCase()}
    </span>
  );
};

interface TabelaReembolsoProps {
  mode?: string;
  titulos?: TituloItem[] | null;
  totalDeduzir?: number;
  readOnly?: boolean;
}

const TabelaReembolso = ({
  mode = "titulos",
  titulos = [],
  totalDeduzir = 0,
}: TabelaReembolsoProps) => {
  const rows = useMemo(
    () => (Array.isArray(titulos) ? titulos : []) as TituloItem[],
    [titulos],
  );

  if (mode !== "titulos") return null;
  if (rows.length === 0) return null;

  return (
    <div className="card shadow-sm p-4 mb-4 card-rounded">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold text-uppercase m-0 text-primary">
          Títulos deduzidos no extrato
        </h5>
      </div>

      <div className="table-rounded-wrapper">
        <div className="table-responsive">
          <table className="table table-titulos mb-0">
            <colgroup>
              <col className="col-filial" />
              <col className="col-numero-titulo" />
              <col className="col-natureza" />
              <col className="col-emissao" />
              <col className="col-vencimento" />
              <col className="col-atraso" />
              <col className="col-valor" />
              <col className="col-historico" />
              <col className="col-status" />
            </colgroup>

            <thead>
              <tr>
                <th>Filial</th>
                <th>Nº Título</th>
                <th>Natureza</th>
                <th>Emissão</th>
                <th>Vencimento</th>
                <th>Dias em atraso</th>
                <th>Valor Bruto</th>
                <th>Histórico</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((t, idx) => (
                <tr key={idx}>
                  <td className="text-center">
                    {t?.filial || "-"}
                  </td>

                  <td className="text-center">
                    {t?.numeroTitulo || t?.numero || t?.titulo || "-"}
                  </td>

                  <td className="text-center">
                    {t?.natureza || "-"}
                  </td>

                  <td className="text-center">
                    {formatDateBR(t?.emissao)}
                  </td>

                  <td className="text-center">
                    {formatDateBR(t?.vencimento)}
                  </td>

                  <td className="text-center">
                    {t?.atrasoDias ?? t?.atraso ?? "-"}
                  </td>

                  <td className="text-center">
                    {formatCurrency(t?.valor)}
                  </td>

                  <td
                    className="col-historico-cell"
                    title={t?.historico || undefined}
                  >
                    {String(t?.historico || "-").toUpperCase()}
                  </td>

                  <td className="text-center">
                    <StatusText value={t?.status} />
                  </td>
                </tr>
              ))}

              <tr className="row-total-deduzir">
                <td colSpan={8} className="text-end fw-bold">
                  VALOR TOTAL A DEDUZIR
                </td>

                <td className="text-center fw-bold valor-total-deduzir">
                  {formatCurrency(totalDeduzir)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TabelaReembolso;